// Ping website brand colors, interleaved with warm tints for chart series.
export const PALETTE = [
  "#f32c01", // Primary orange
  "#d39b00", // Gold
  "#b00000", // Deep red
  "#80756e", // Warm gray
  "#f58a60", // Orange tint
  "#b08100", // Dark gold
  "#d30000", // Red
  "#c5aca0", // Warm neutral
  "#a84b32", // Terracotta
  "#e5bd60", // Gold tint
  "#cf7770", // Red tint
  "#594a43", // Warm charcoal
];

// Source codes and display names from dataweb/dataweb/dataapi/datasources.
// Legacy codes without a datasource use dataapi/models/constants.py.
export const SOURCES: Readonly<Record<string, string>> = {
  AG: "Apple Maps Geocoding",
  AGR: "Apple Maps Reverse Geocoding",
  AON_CS_EQ: "AON Cat Score EQ",
  AON_CS_FLD: "AON Cat Score Flood",
  AON_CS_SCS: "AON Cat Score SCS",
  AON_CS_WF: "AON Cat Score Wild Fire",
  AZG: "Azure Geocoding",
  BBR: "BuildBrain",
  BG: "Bing",
  BGR: "Bing Reverse Geocoding",
  BI: "Barrier Island",
  BQ: "BrightQuery",
  BQBI: "BrightQuery Business Identity",
  BQFE: "BrightQuery Firmographics Extraction",
  BQFT: "BrightQuery Family Tree Extraction",
  BQLE: "BrightQuery Locations Extraction",
  BV: "Betterview",
  CA: "Cape Analytics",
  CALSD: "Canadian LSD Coordinates",
  CHAOS: "Chaos Monkey",
  CLS_CRS: "CoreLogic Spatial Crime Risk Score",
  CLS_CSRS: "CoreLogic Spatial Coastal Storm Risk Score",
  CLS_DTFST: "CoreLogic Spatial Distance to FireStation",
  CLS_EQRS: "CoreLogic Spatial Earthquake Risk Score",
  CLS_FFRS: "CoreLogic Spatial Flash Flood Risk Score",
  CLS_FRS: "CoreLogic Spatial Flood Risk Score",
  CLS_HI: "CoreLogic Spatial Hail Insight",
  CLS_HR: "CoreLogic Spatial Hail Risk",
  CLS_NWFRS: "CoreLogic Spatial Non-Weather FireRisk Score",
  CLS_NWWRS: "CoreLogic Spatial Non-Weather WaterRisk Score",
  CLS_WFRS: "CoreLogic Spatial Wildfire Risk Score",
  CLS_WRS: "CoreLogic Spatial Wind Risk Score",
  DTC: "Distance To Coast",
  DTFH: "Distance To Fire Hydrant",
  DTFS: "Distance To Florida Sinkhole",
  DTFST: "Distance To Fire Station",
  DTFZ: "Distance To Flood Zone",
  E2V: "e2Value ProntoLite Commercial",
  E2VR: "e2Value ProntoLite Residential",
  EC: "Easi Crime",
  EG: "Esri Geocoding",
  EGR: "Esri Reverse Geocoding",
  EVMR: "Everest Maprisk",
  FNRI: "Fema National Risk Index",
  FS_WF: "First Street Fire Factor",
  GAV: "Google Address Validation",
  GC_HZ: "Guy Carp Hazard",
  GEV: "Google Elevation",
  GG: "Google Geocoding",
  GGB: "Google Geocoding Beta",
  GGP: "Google POI Geocoding",
  GGR: "Google Reverse Geocoding",
  GGV4: "Google Geocoding V4",
  GIO: "Geocodio",
  GS_RS: "Property Guardian Wildfire Resiliency Score",
  GS_WF_RS: "Property Guardian Wildfire Recurrence Scores",
  GS_WMI: "Property Guardian Wildfire Moratorium Insights",
  HG: "Here Geocoding",
  HH: "Hazardhub",
  IMF: "Intermap Flood",
  JBA_FD: "JBA Flood Depths",
  JBA_FS: "JBA Flood Scores",
  KR: "Katrisk",
  LB: "Lightbox",
  LBFZ: "Lightbox Flood Zone",
  LBG: "Lightbox Geocoding",
  LBGR: "Lightbox Reverse Geocoding",
  LBP: "Lightbox Parcel",
  LBS: "Lightbox Structures",
  LBSS: "Lightbox Spatial Stream",
  LP: "LibPostal",
  MD: "Messy Data",
  NOOP: "No Op Datasource",
  OFAC: "OFAC Sanctions Screening",
  PCO: "Ping COPE",
  PFF: "FEMA Flood Zone",
  PFFT: "Fema Flood Zone V2",
  PFPC: "Ping Fire Protection Classification",
  PG: "Ping Geocoding",
  PGB: "Ping Geocoding Beta",
  PGPOST: "Ping Geo Post",
  PGPRE: "Ping Geo Pre",
  PH: "Ping Hazard",
  PH2: "Ping Hazard V2",
  PHHT: "Historical Hurricane Tracks",
  PN: "Ping NAICS",
  PO: "Ping Occupancy",
  PP: "Permits",
  PPPC: "Prometrix PPC",
  PSG: "Precisely Geocoding",
  PSM: "Ping Secondary Modifier",
  PSZ: "Slosh Zone",
  PUSDAW: "USDA Wildfire",
  PVAL: "Ping Valuation",
  PVIQ: "Ping Valuation Invert Quantile",
  PVQ: "Ping Valuation Quantile",
  Q: "Quantarium",
  REASKM: "Reask Metryc",
  RMSLCP: "RMS Loss Cost Pricing",
  RMS_US_ESDB: "RMS US ExposureSource Database",
  RZR: "Redzone Risk",
  R_G: "Ryan Geocoding",
  R_H_V3: "Ryan Hazard V3",
  R_KR: "Ryan Katrisk",
  R_N: "Ryan Nearmap",
  R_P_W: "Ryan Precisely Wildfire",
  SM: "Smarty Street Address",
  SW_EQ: "Swiss Re Earthquake",
  SW_HS: "Swiss Re Hailstorm",
  SW_LT: "Swiss Re Lightning",
  SW_SS: "Swiss Re Stormsurge",
  SW_TD: "Swiss Re Tornado",
  SW_TSNMI: "Swiss Re Tsunami",
  SW_WF: "Swiss Re Wildfire",
  SW_WS: "Swiss Re Windstorm",
  T4D: "Teren 4D",
  TD: "Test Datasource",
  TFR_FFH: "True Flood Risk First Floor Height",
  TF_WWLS: "Terrafuse AI Wildfire Risk Score",
  TRAIR: "Tiger Risk AIR",
  TRRMS: "Tiger Risk RMS",
  USDAERPS: "USDA Enhanced Risk to Potential Structures",
  USGS_WBD: "USGS Watershed Boundary Dataset",
  VPD: "Vexcel Elements AI: Damage Assessment",
  VPI: "Vexcel Elements AI: Property & Building Attributes",
};
